<template>
	<div>
		<vs-prompt
			title="Export To Excel"
			class="export-options"
			@cancle="clearFields"
			@accept="exportToExcel"
			accept-text="Export"
			@close="clearFields"
			:active.sync="activePrompt"
		>
			<vs-input v-model="fileName" placeholder="Enter File Name.." class="w-full" />
			<v-select v-model="selectedFormat" :options="formats" class="my-4">
				<template v-slot:no-options="{search, searching}">
					<template v-if="searching">
						{{ $t("general.NoResultsFoundFor") + " " }}<em>{{ search }}</em>
					</template>
				</template>
			</v-select>
			<div class="flex">
				<span class="mr-4">{{ $t("MapModule.CellAutoWith") }}:</span>
				<vs-switch v-model="cellAutoWidth">{{ $t("MapModule.CellAutoWith") }}</vs-switch>
			</div>
		</vs-prompt>
		<div class="export-table">
			<vs-table :data="dataEventsDay" v-model="selectedUsers" multiple search>
				<template slot="header">
					<vx-tooltip class="cursor-pointer" position="top" :text="$t('ExportSelected')">
						<vs-button
							color="primary"
							type="filled"
							icon-pack="feather"
							icon="icon-download"
							@click.prevent="showActivePrompt"
						></vs-button>
					</vx-tooltip>
				</template>
				<template slot="thead">
					<vs-th class="g-table--title"> N.</vs-th>
					<vs-th class="g-table--title"> {{ $t("VisitPoint") }}</vs-th>
					<vs-th class="g-table--title"> {{ $t("Address") }}</vs-th>
					<vs-th class="g-table--title"> {{ $t("general.Hour") }}</vs-th>
					<vs-th class="g-table--title"> {{ $t("Status") }}</vs-th>
				</template>
				<template slot-scope="{data}">
					<vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
						<vs-td class="g-table--description">{{ indextr + 1 }}</vs-td>
						<vs-td class="g-table--description">{{ tr.visit_point_name }}</vs-td>
						<vs-td class="g-table--description">{{ data[indextr].address }}</vs-td>
						<vs-td class="g-table--description"
							>{{ data[indextr].init_hour + " - " + data[indextr].end_hour }}
						</vs-td>
						<vs-td>
							<vs-chip :color="chipColor(data[indextr].event_status_id)"
								>{{ chipLabel(data[indextr].event_status_id) }}
							</vs-chip>
						</vs-td>
					</vs-tr>
				</template>
			</vs-table>
		</div>
	</div>
</template>

<script>
import vSelect from "vue-select";

export default {
	components: {
		vSelect,
	},
	data() {
		return {
			fileName: "",
			formats: ["xlsx", "csv", "txt"],
			cellAutoWidth: true,
			selectedFormat: "xlsx",
			headerTitle: ["Id", "Punto de Visita", "Direccion", "Hora Inicial", "Estado"],
			headerVal: ["id", "visit_point_name", "address", "init_hour", "status_id"],
			users: [
				{
					id: 1,
					name: "Leanne Graham",
					username: "Bret",
					status: "Finished",
					website: "08:30:00",
				},
			],
			selectedUsers: [],
			activePrompt: false,
			colors: {
				agendado: "#3AAAFF",
				reprogramado: "#FFE15A",
				cancelado: "#FF0000",
				finalizado: "#28c76f",
				en_proceso: "#113a60",
			},
		};
	},
	computed: {
		dataEventsDay() {
			return this.$store.state.moduleSchedule.events ? this.$store.state.moduleSchedule.events : [];
		},
		chipColor() {
			return (label) => {
				switch (label) {
					case 1:
						return this.colors["NOT_ASSIGNED"];
						break;
					case 2:
						return this.colors["agendado"];
						break;
					case 3:
						return this.colors["reprogramado"];
						break;
					case 4:
						return this.colors["DELAYED"];
						break;
					case 5:
						return this.colors["ON_THE_WAY"];
						break;
					case 6:
						return this.colors["en_proceso"];
						break;
					case 7:
						return this.colors["finalizado"];
						break;
					case 8:
						return this.colors["cancelado"];
						break;
					default:
						break;
				}
			};
		},
		chipLabel() {
			return (label) => {
				switch (label) {
					case 1:
						return "NOT_ASSIGNED";
						break;
					case 2:
						return "agendado";
						break;
					case 3:
						return "reprogramado";
						break;
					case 4:
						return "DELAYED";
						break;
					case 5:
						return "ON_THE_WAY";
						break;
					case 6:
						return "en_proceso";
						break;
					case 7:
						return "finalizado";
						break;
					case 8:
						return "cancelado";
						break;
					default:
						break;
				}
			};
		},
	},
	methods: {
		closePopupEmit() {
			this.$emit("closePopupEmit");
		},
		showActivePrompt() {
			this.activePrompt = true;
			this.$emit("closePopupEmit");
		},
		exportToExcel() {
			import("@/vendor/Export2Excel").then((excel) => {
				const list = this.selectedUsers;
				const data = this.formatJson(this.headerVal, list);
				excel.export_json_to_excel({
					header: this.headerTitle,
					data,
					filename: this.fileName,
					autoWidth: this.cellAutoWidth,
					bookType: this.selectedFormat,
				});
				this.clearFields();
			});
		},
		formatJson(filterVal, jsonData) {
			return jsonData.map((v) =>
				filterVal.map((j) => {
					// Add col name which needs to be translated
					// if (j === 'timestamp') {
					//   return parseTime(v[j])
					// } else {
					//   return v[j]
					// }

					return v[j];
				})
			);
		},
		clearFields() {
			this.fileName = "";
			this.cellAutoWidth = true;
			this.selectedFormat = "xlsx";
			this.$emit("unmountExportEmit");
		},
	},
};
</script>
<style lang="scss" scoped>
.bg-agendado {
	background-color: #3aaaff !important;
}

.bg-reprogramado {
	background-color: #ffe15a !important;
}

.bg-cancelado {
	background-color: #ff0000 !important;
}

.bg-finalizado {
	background-color: #28c76f !important;
}

.bg-en_proceso {
	background-color: #113a60 !important;
}

.bg-delayed {
	background-color: #ff7070 !important;
}

.bg-on-the-way {
	background-color: #ffbe81 !important;
}

.bg-selected {
	background-color: #a0a0a0 !important;
}

.bg-ondemand {
	background-color: #886ce4 !important;
}
</style>
